import type { Ref } from "vue"

interface VersionReloadRouter {
  beforeEach(guard: () => true): void
  afterEach(hook: (to: { fullPath: string }) => void): void
}

export function initializeVersionReload(router: VersionReloadRouter, newVersionAvailable: Ref<boolean>): void {
  let shouldReload = false

  router.beforeEach(() => {
    if (newVersionAvailable.value) {
      shouldReload = true
    }
    return true
  })

  router.afterEach((to) => {
    if (shouldReload) {
      window.location.href = to.fullPath
    }
  })
}
